import React, { Component } from 'react';

function getExperience() {
	const exp = window.localStorage.getItem('experience') || 'internal';
	return String(exp).toLowerCase();
}

class Footer extends Component {
	render() {
		const footer = this.props.footer || {};
		const experience = getExperience();

		const internalLinks = Array.isArray(footer.footerLinks) ? footer.footerLinks : [];
		const seasonalLinks = Array.isArray(footer.seasonalFooterLinks) ? footer.seasonalFooterLinks : [];

		// Seasonal falls back to internal list if seasonal list not provided.
		const footerLinksToRender =
			experience === 'seasonal' && seasonalLinks.length > 0 ? seasonalLinks : internalLinks;

		const secondaryLinks = Array.isArray(footer.secondaryFooterLinks) ? footer.secondaryFooterLinks : [];

		return (
			<footer id="site-footer" className="container" role="contentinfo">
				<div className="row">
					<div className="col md-12">
						<div className="footer-logo"></div>
						<div className="footer-content">
							<div className="copyright">
								<small></small>
								<small>{footer.footerHeader}</small>
							</div>

							<nav className="footer-nav">
								<h2 className="assistive-text">Footer Navigation</h2>

								<ul className="footer-nav__list">
									{footerLinksToRender.map((link, index) => {
										return (
											<li key={index}>
												<a href={link.route}>{link.text}</a>
											</li>
										);
									})}
								</ul>

								<ul className="secondary-footer-nav footer-nav__list footer-nav__list--secondary">
									{secondaryLinks.map((link, index) => {
										return (
											<li key={index} className="external">
												<a href={link.route}>{link.text}</a>
											</li>
										);
									})}
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
